import React from 'react'
import { Separator, Button, H1 } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { SignUpDivider } from '@fs/identity.js'
import SocialProviderLinksRow from './SocialProviderLinksRow'
import LoginForm from './LoginForm'
import LegalText from './LegalText'
import { useGoHomeIfNoSession, useShowUseMyPhone, useSiteLink } from '../hooks'
import ErrorFromUrl from './ErrorFromUrl'
import QrLoginButton from './QrLoginButton'
import SignUpLink from './SignUpLink'

const LoginPage = () => {
  usePageView({ page_detail: 'Sign In to FamilySearch' })
  useGoHomeIfNoSession()
  const { i18n, t } = useTranslation()
  const signupLink = useSiteLink({ pathname: '/identity/signup/' })
  const showUseMyPhoneButton = useShowUseMyPhone()
  const hasNewToFamilySearchLabel = !!i18n.getResource(i18n.language, 'translation', 'new-to-familysearch.label')

  return (
    <>
      <H1 size="H4">{t('common-ui:sign-in.action', 'Sign In')}</H1>
      <Separator size="xs" />
      <ErrorFromUrl />
      {showUseMyPhoneButton && (
        <>
          <QrLoginButton />
          <Separator size="xs" />
        </>
      )}
      <SocialProviderLinksRow />
      <Separator size="nano" />
      <SignUpDivider />
      <Separator size="xs" />
      <Separator size="nano" />
      <LoginForm />
      <Separator size="xs" />
      {hasNewToFamilySearchLabel ? (
        <SignUpLink />
      ) : (
        <Button fullWidth emphasis="medium" to={signupLink} linkName="Create a Free Account" id="create-account">
          {t('sign-up.action', 'Create a Free Account')}
        </Button>
      )}

      <LegalText />
    </>
  )
}

export default LoginPage
